import { createContext, ReactNode, useState } from 'react';
import { api } from '../server/api';
import { IRating } from '../interfaces/IRating';

interface RatingContextProviderProps {
  children: ReactNode;
}

interface RatingContextProps {
  rating: IRating;
  getRating: (playerId: string) => void;
  postRating: (
    actionId: string,
    leadId: string,
    playerId: string,
    newRate: number
  ) => void;
}

export const ratingContext = createContext({} as RatingContextProps);

export function RatingContextProvider(props: RatingContextProviderProps) {
  const [rating, setRating] = useState<IRating>();

  async function getRating(playerId: string) {
    try {
      const { data } = await api.get(`/ratings/${playerId}`);

      if (data.body) {
        setRating(data.body);
      }
    } catch (error) {
      console.log('getRating error: ', error);
    }
  }

  async function postRating(
    actionId: string,
    leadId: string,
    playerId: string,
    newRate: number
  ) {
    try {
      const parameters = {
        actionId,
        leadId: leadId,
        playerId,
        rating: newRate,
      };
      await api.post('/ratings/player', parameters);
    } catch (error) {
      console.log('postRating error: ', error);
    }
  }

  return (
    <ratingContext.Provider
      value={{
        rating,
        getRating,
        postRating,
      }}
    >
      {props.children}
    </ratingContext.Provider>
  );
}
